import { toast } from 'sonner'

type LogLevel = 'error' | 'warn' | 'info'

function extractMessage(value: unknown): string | null {
  if (value == null) return null
  if (typeof value === 'string') return value.trim() || null
  const err = value as {
    response?: { data?: { error?: unknown; detail?: unknown; message?: unknown } }
    message?: unknown
  }
  const data = err.response?.data
  const candidate = data?.error ?? data?.detail ?? data?.message ?? err.message
  if (typeof candidate === 'string' && candidate.trim()) return candidate
  return null
}

function log(level: LogLevel, tag: string, message: string, error?: unknown) {
  const prefix = `[${tag}]`
  if (level === 'error') {
    console.error(prefix, message, error ?? '')
  } else if (level === 'warn') {
    console.warn(prefix, message, error ?? '')
  } else {
    console.info(prefix, message)
  }
}

export const logger = {
  error(tag: string, messageOrError: string | unknown, error?: unknown) {
    // Accept either a plain string, an error object, or a string fallback + error.
    // When an error object is available, prefer its extracted backend message.
    const rawError = error ?? (typeof messageOrError === 'string' ? undefined : messageOrError)
    const fallback = typeof messageOrError === 'string' ? messageOrError : 'Something went wrong'
    const toastMessage = extractMessage(rawError) ?? fallback
    log('error', tag, toastMessage, rawError)
    toast.error(toastMessage)
  },

  warn(tag: string, message: string) {
    log('warn', tag, message)
    toast.warning(message)
  },

  info(tag: string, message: string) {
    log('info', tag, message)
  },

  success(tag: string, message: string) {
    log('info', tag, message)
    toast.success(message)
  },
}
